import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "@/lib/i18n";
import { Reveal } from "./Reveal";

const Word = ({ word, i, total, progress }) => {
  const start = i / total;
  const opacity = useTransform(progress, [start, start + 1 / total], [0.28, 1]);
  return <motion.span style={{ opacity }} className="inline-block mr-[0.25em]">{word}</motion.span>;
};

export const Manifesto = () => {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.85", "end 0.45"] });
  const words = t.manifesto.text.split(" ");
  return (
    <section id="casa" className="relative py-28 md:py-44 bg-[#0A0A0C] overflow-hidden" data-testid="manifesto-section">
      <div className="pointer-events-none absolute -right-40 top-10 h-[520px] w-[520px] rounded-full bg-[#C5A059]/10 blur-[120px]" />
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <Reveal y={20}><p className="eyebrow mb-10">{t.manifesto.over}</p></Reveal>
        <p ref={ref} className="font-display font-light text-3xl sm:text-5xl lg:text-[4.2rem] leading-[1.08] tracking-tight text-[#F9F9F9] max-w-6xl" data-testid="manifesto-text">
          {words.map((w, i) => <Word key={w + i} word={w} i={i} total={words.length} progress={scrollYProgress} />)}
        </p>
        <div className="mt-20 md:mt-28 grid sm:grid-cols-2 lg:grid-cols-4 border-t border-white/10">
          {t.manifesto.pillars.map(([title, text], i) => (
            <Reveal key={title} delay={i * 0.08} className="border-b sm:border-b-0 sm:border-r last:border-r-0 border-white/10 py-10 sm:px-8 first:sm:pl-0">
              <div data-testid={`pillar-${i}`}>
                <span className="block h-2.5 w-2.5 rotate-45 bg-[#C5A059] mb-8" />
                <h3 className="font-display text-3xl text-[#F9F9F9]">{title}</h3>
                <p className="mt-3 text-sm md:text-base text-zinc-300 leading-relaxed">{text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
